module.exports = __webpack_public_path__ + "img/GasEngines.e228e6f5.jpg";